module.exports = __webpack_public_path__ + "static/img/footerBanner.089167c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerBanner.png
// module id = gi/i
// module chunks = 1